var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.name ==='login' || _vm.$route.name ==='reset' ||  _vm.$route.name ==='register')?_c('NoLayout',[_c('router-view')],1):_c('AppLayout',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('notifications',{attrs:{"position":"bottom left","classes":"notification-card"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }